import api from './api';
import { Post } from '../types';

export const postsService = {
    // Get all posts for the user
    getAll: async (): Promise<Post[]> => {
        const response = await api.get('/posts');
        return response.data;
    },

    // Get posts for a page
    getByPage: async (pageId: string): Promise<Post[]> => {
        const response = await api.get(`/posts?pageId=${pageId}`);
        return response.data;
    },

    // Create new post
    create: async (data: any) => {
        const response = await api.post('/posts', data);
        return response.data;
    },

    // Sync posts from Facebook
    sync: async (pageId: string) => {
        const response = await api.post(`/posts/sync/${pageId}`);
        return response.data;
    },

    // Copy post to multiple pages
    copy: async (postId: string, targetPageIds: string[]) => {
        const response = await api.post(`/posts/${postId}/copy`, { targetPageIds });
        return response.data;
    },

    // Get related posts in a campaign
    getRelated: async (postId: string): Promise<Post[]> => {
        const response = await api.get(`/posts/${postId}/related`);
        return response.data;
    },

    // Get post stats
    getStats: async (postId: string) => {
        const response = await api.get(`/posts/${postId}/stats`);
        return response.data;
    },

    delete: async (postId: string) => {
        const response = await api.delete(`/posts/${postId}`);
        return response.data;
    },

    // Get pending/failed posts in queue
    getQueue: async () => {
        const response = await api.get('/posts/queue');
        return response.data;
    },

    // Get fresh details from Facebook
    getFacebookDetails: async (postId: string) => {
        const response = await api.get(`/posts/${postId}/facebook`);
        return response.data;
    },
};
